import React from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

function NuevaPlantillaConsentimiento() {

    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    
    const [titulo, setTitulo] = useState('');
    const [contenido, setContenido] = useState('');
    const [errorlist, setErrorlist] = useState({});

    let history = useHistory();

    let userdata = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a administrar plantillas
        const tienePermiso = userdata.up && userdata.up.includes('administrarPlantillas');
        
        if (!tienePermiso) {
            // Si no tiene permisos, redirigir o mostrar error
            console.log('Sin permisos para administrar plantillas');
            return;
        }

        axios.get('/get-client')
            .then(response => {
                if (response.status===200) {
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: '+error);
            });
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const data = {
            titulo: titulo,
            contenido: contenido
        };
        
        console.log('Enviando datos:', data);
        axios.post('/plantilla-consentimiento', data)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('toastmsg','La Plantilla "'+titulo+'" Ha Sido Creada');
                    history.push('/plantillas-consentimientos');
                }
            )
            .catch(
                err => {
                    console.log('Error completo:', err);
                    if (err.response && err.response.data && err.response.data.errors) {
                        setErrorlist(err.response.data.errors);
                    } else {
                        setErrorlist({});
                        console.log('Error sin estructura de validación:', err.response?.data || err.message);
                    }
                    setLoading(false);
                }
            )
    }

    const contenidoHandler = (event, editor) => {
        setContenido(editor.getData());
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/administrar-plantillas">Administrar Plantillas</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/plantillas-consentimientos">Otras Plantillas y Consentimientos</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Nueva Plantilla</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Nuevo Consentimiento Informado</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                            <div className="col-md-12">
                                
                                <div className="card">
                                <div id="infobasica">
                                    <div className="card-body">

                                        <form id="role-form" onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="titulo">Título</label>
                                                        <input type="text" name="titulo" className="form-control" id="titulo" onChange={(e) => setTitulo(e.target.value)} required />
                                                        {errorlist.titulo && (
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.titulo}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="contenido">Consentimiento</label>
                                                        <CKEditor editor={ClassicEditor} onChange={contenidoHandler} />
                                                        {errorlist.contenido && (
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.contenido}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row" style={{marginTop: '30px'}}>
                                                <div className="col-md-12">
                                                    <div className="d-flex gap-2">
                                                        <Link to="/plantillas-consentimientos" className="btn btn-secondary">
                                                            Cancelar
                                                        </Link>
                                                        <button type="submit" className="btn btn-primary" disabled={loading}>
                                                            Crear Plantilla&nbsp;
                                                            {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                </div>

                            </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default NuevaPlantillaConsentimiento;